import React from 'react';
import { Tooltip } from 'react-tooltip';
import { get } from 'lodash-es';
import { useSelector } from 'react-redux';
import { getMyVideoUploaderSelector, getMyVideoResponsibleSelector } from 'pages/my-videos.page/selectors';
import { parseISO } from 'date-fns';

import { Plays, UploadDate } from 'components/video-metadata/fragments';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/pro-solid-svg-icons';
import { faUserFriends } from '@fortawesome/pro-duotone-svg-icons';
import { useTranslation } from 'react-i18next';

const UserName = ({ name, dataE2e, icon, label }) => {
  return name ? (
    <span data-e2e={dataE2e} className="ct-video-metadata__li ct-video-metadata__icon ct-video-metadata__icon--user">
      <FontAwesomeIcon className="video-metadata-icon" icon={icon} />
      <span className="ct-video-metadata__span d-none d-md-inline-block">{`${label}:`}&nbsp;</span>
      {name}
    </span>
  ) : null;
};

const UploaderUserName = () => {
  const { t } = useTranslation();
  const name = get(useSelector(getMyVideoUploaderSelector), 'fullName', t('admin_in_vmpro'));

  return <UserName name={name} dataE2e="video-uploader-user-name" label={t('uploaded_by')} icon={faUser} />;
};

const ResponsibleUserName = () => {
  const { t } = useTranslation();
  const name = get(useSelector(getMyVideoResponsibleSelector), 'fullName');

  return (
    <UserName name={name} dataE2e="video-responsible-user-name" label={t('person_in_charge')} icon={faUserFriends} />
  );
};

export const VideoMetadata = ({ video }) => {
  const videoPlays = get(video, 'plays');
  const videoDate = get(video, 'createdDate') ? parseISO(video.createdDate) : new Date();

  return (
    <div data-e2e="video-metadata">
      <div className="ct-video-metadata ct-video-metadata--vertical">
        <UploaderUserName />
        <ResponsibleUserName />
        <UploadDate date={videoDate} />
        <Plays plays={videoPlays} extraMargin={true} />
      </div>
      <Tooltip
        id="videoMetadataTooltip"
        place="top"
        effect="solid"
        type="dark"
        className={'tooltip-restyle'}
        globalEventOff="click"
      />
    </div>
  );
};
